<template>
    <div>
        <div class="bg-white rounded-sm p-4">
            <div class="flex flex-col z-10">
                <div class="md:h-10 mb-4 md:mb-2">
                    <div class="flex justify-between items-center h-full">
                        <span class="font-medium text-lg">Webhooks</span>
                        <button class="outline-none btn btn-primary" v-show="!showKey" @click.prevent="generateKey">Generate New Secret Client Key</button>
                    </div>
                </div>
                <div class="md:h-7" v-if="hasKey">
                    <div class="flex flex-col md:flex-row md:items-center h-full">
                        <span class="ml-2 font-bold">Webhook Secret Client Key</span>
                        <button class="outline-none bg-gray-200 py-1 px-2 rounded-sm ml-2 md:ml-3"
                                v-if="!showKey" @click.prevent="showKeyForTenSeconds">Reveal Key
                        </button>
                        <div class="flex flex-col ml-2 md:ml-3" v-if="showKey">
                            <span>{{ clientKey }}</span>
                            <div class="h-1 relative max-w-xl rounded-full overflow-hidden">
                                <div id="bar" class="transition-all ease-linear duration-10000 relative w-full h-full bg-gray-200"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            clientKey: "",
            hasKey: false,
            showKey: false
        };
    },

    mounted () {
        this.checkIfClientKeyExists();
    },

    methods: {
        checkIfClientKeyExists () {
            axios.get("/settings/webhook")
            .then(response => {
                if (response.data.length > 0) {
                    this.hasKey = true;
                }
            })
            .catch(errors => {
                toastr.error(errors.message);
            });
        },

        generateKey () {
            axios.patch("/settings/webhook/generate")
            .then(() => {
                this.hasKey = true;
                toastr.success("New secret key generated");
            })
            .catch(errors => {
                toastr.error(errors.message);
            });
        },

        showKeyForTenSeconds () {
            // only set the key when fetching to reveal the key
            axios.get("/settings/webhook")
            .then((response) => {
                this.clientKey = response.data;
                this.showKey = true;
                //give vue 15 milliseconds to render the bar
                this.sleep(15).then(() => {
                    let bar = document.getElementById("bar");
                    bar.classList.remove("w-full");
                    bar.classList.add("w-0");
                });

                this.sleep(10000).then(() => {
                    this.showKey = false;
                    this.clientKey = null;
                });
            });
        },

        // sleep time expects milliseconds
        sleep (time) {
            return new Promise((resolve) => setTimeout(resolve, time));
        },
    },

};
</script>

<style scoped>

</style>